import { IonButton, IonButtons, IonContent, IonGrid, IonLabel, IonList, IonRow, IonToolbar } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { getPtsOptionsSelector } from '../../../../options/selectors/ptsOptions.selector'
import { getPediatricTraumaScoreSelector } from '../selectors'
import {
  resetPtsData,
  savePTSData,
  setAirway,
  setCns,
  setOpenWounds,
  setSize,
  setSkeletalInjury,
  setSysBP,
} from '../store/pediatricTraumaScore.actions'
import { IOption } from '../../../../../common/common.types'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'
import { useHistory } from 'react-router'
import './PediatricTraumaScore.content.css'

const PediatricCommaScoreContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const ptsOptions = useSelector(getPtsOptionsSelector)
  const { ptsSizeOptions, ptsAirwayOptions, ptsBpOptions, ptsCnsOptions, ptsSkelOptions, ptsWoundOptions } = ptsOptions

  const pediatricTraumaScoreState = useSelector(getPediatricTraumaScoreSelector)
  const { ptsSize, ptsAir, ptsBp, ptsCns, ptsSkel, ptsTotal, ptsWound } = pediatricTraumaScoreState

  const savePTSDataOnChange = () => {
    dispatch(savePTSData())
  }

  const setPtsSizeOnChange = (option: IOption) => {
    dispatch(setSize(option))
    savePTSDataOnChange()
  }

  const setPtsAirwayOnChange = (option: IOption) => {
    dispatch(setAirway(option))
    savePTSDataOnChange()
  }

  const setPtsBpOnChange = (option: IOption) => {
    dispatch(setSysBP(option))
    savePTSDataOnChange()
  }

  const setPtsCnsOnChange = (option: IOption) => {
    dispatch(setCns(option))
    savePTSDataOnChange()
  }

  const setPtsSkelOnChange = (option: IOption) => {
    dispatch(setSkeletalInjury(option))
    savePTSDataOnChange()
  }

  const setPtsWoundOnChange = (option: IOption) => {
    dispatch(setOpenWounds(option))
    savePTSDataOnChange()
  }

  const resetPediatricData = () => {
    dispatch(resetPtsData())
    savePTSDataOnChange()
  }

  return (
    <>
      <IonContent className='ion-margin-bottom' fullscreen>
        <IonList>
          <IonGrid>
            <IonRow className='ion-margin-bottom'>
              <IonLabel>{t('neuro.pediatricTraumaScore.ptsTotal')}</IonLabel>
              {ptsTotal != null && <IonLabel className='custom-number-label'> {ptsTotal}</IonLabel>}
            </IonRow>
            <SingleSelect
              dataTestID='ptsSize'
              options={ptsSizeOptions}
              selectedOption={ptsSize}
              listHeader={t('neuro.pediatricTraumaScore.ptsSize')}
              label={t('neuro.pediatricTraumaScore.ptsSize')}
              action={setPtsSizeOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='ptsAir'
              options={ptsAirwayOptions}
              selectedOption={ptsAir}
              listHeader={t('neuro.pediatricTraumaScore.ptsAir')}
              label={t('neuro.pediatricTraumaScore.ptsAir')}
              action={setPtsAirwayOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='ptsBp'
              options={ptsBpOptions}
              selectedOption={ptsBp}
              listHeader={t('neuro.pediatricTraumaScore.ptsBp')}
              label={t('neuro.pediatricTraumaScore.ptsBp')}
              action={setPtsBpOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='ptsCns'
              options={ptsCnsOptions}
              selectedOption={ptsCns}
              listHeader={t('neuro.pediatricTraumaScore.ptsCns')}
              label={t('neuro.pediatricTraumaScore.ptsCns')}
              action={setPtsCnsOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='ptsSkel'
              options={ptsSkelOptions}
              selectedOption={ptsSkel}
              listHeader={t('neuro.pediatricTraumaScore.ptsSkel')}
              label={t('neuro.pediatricTraumaScore.ptsSkel')}
              action={setPtsSkelOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='ptsWound'
              options={ptsWoundOptions}
              selectedOption={ptsWound}
              listHeader={t('neuro.pediatricTraumaScore.ptsWound')}
              label={t('neuro.pediatricTraumaScore.ptsWound')}
              action={setPtsWoundOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
          </IonGrid>
        </IonList>
      </IonContent>
      <IonToolbar color='light' className='p-10'>
        <IonButtons className='btn-grps'>
          <IonButton
            className='btn btn-tablet'
            color='danger'
            fill='outline'
            expand='block'
            onClick={resetPediatricData}>
            {t('common.buttons.Clear')}
          </IonButton>
          <IonButton
            className='btn btn-tablet btn-primary'
            expand='block'
            onClick={() => {
              history.push(TabConstants.INITIAL_ASSESSMENT)
            }}>
            {t('common.buttons.Save')}
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </>
  )
}

export default PediatricCommaScoreContent
